import React, { useEffect } from 'react';
import BookingTimeTable from './BookingTimeTable';
import BookingTimeTableLegend from './BookingTimeTableLegend';
import { formatDateToString, getHourLists } from 'utils/time';
import { utcToZonedTime } from 'date-fns-tz';

export default function BookingTimeSelector({
  bookings,
  buildingTimezone,
  selectedResourceUuid,
  selectedDate,
  openTime,
  closeTime,
  handleStartChange,
  handleEndChange,
  editStart,
  editEnd,
  bookingStartDate,
  bookingEndDate
}: any) {
  const [start, setStart] = React.useState<number>(editStart);
  const [end, setEnd] = React.useState<number>(editEnd);

  useEffect(() => {
    // Convert Selected Date to the building's timezone
    const selectedDateTime = utcToZonedTime(selectedDate, buildingTimezone);
    // Convert start and end date and time to Date format (in provided timezone)
    const startDate = utcToZonedTime(new Date(bookingStartDate), buildingTimezone);
    const endDate = utcToZonedTime(new Date(bookingEndDate), buildingTimezone);

    /* The below lines of code are converting the selected date, booking start date, and booking end date
    into a specific format (YYYY-MM-DD) using the `formatDateToString` function. */
    const formattedSelectedDate = formatDateToString(selectedDateTime);
    const formattedBookingStartDate = formatDateToString(startDate);
    const formattedBookingEndDate = formatDateToString(endDate);

    if (
      (editStart === 0 && editEnd === 1) ||
      (formattedBookingStartDate !== formattedSelectedDate &&
        formattedBookingEndDate !== formattedSelectedDate)
    ) {
      setStart(0);
      setEnd(1);
    }
  }, [
    selectedResourceUuid,
    selectedDate,
    editStart,
    editEnd,
    bookingStartDate,
    bookingEndDate,
    buildingTimezone
  ]);

  useEffect(() => {
    // Convert Selected Date to the building's timezone
    const selectedDateTime = utcToZonedTime(selectedDate, buildingTimezone);
    // Convert start and end date and time to Date format (in provided timezone)
    const startDate = utcToZonedTime(new Date(bookingStartDate), buildingTimezone);
    const endDate = utcToZonedTime(new Date(bookingEndDate), buildingTimezone);

    /* The below lines of code are converting the selected date, booking start date, and booking end date
    into a specific format (YYYY-MM-DD) using the `formatDateToString` function. */
    const formattedSelectedDate = formatDateToString(selectedDateTime);
    const formattedBookingStartDate = formatDateToString(startDate);
    const formattedBookingEndDate = formatDateToString(endDate);

    if (
      editStart &&
      editEnd &&
      formattedBookingStartDate === formattedSelectedDate &&
      formattedBookingEndDate === formattedSelectedDate
    ) {
      setStart(editStart);
      setEnd(editEnd - 1);
    }
  }, [bookingEndDate, bookingStartDate, buildingTimezone, editEnd, editStart, selectedDate]);

  const hourlists = getHourLists();
  const updateStart = (index: number) => {
    setStart(index);
    handleStartChange(hourlists[index]);
  };

  const updateEnd = (index: number) => {
    setEnd(index);
    handleEndChange(hourlists[index + 1]);
  };

  return (
    <div>
      <label className="text-neutral7 uppercase">Availability</label>
      <BookingTimeTable
        start={start}
        end={end}
        editStart={editStart}
        editEnd={editEnd}
        bookings={bookings}
        buildingTimezone={buildingTimezone}
        updateStart={updateStart}
        updateEnd={updateEnd}
        openTime={openTime}
        closeTime={closeTime}
        selectedDate={selectedDate}
        bookingStartDate={bookingStartDate}
        bookingEndDate={bookingEndDate}
      />
      <BookingTimeTableLegend />
    </div>
  );
}
